import React, { useEffect } from "react"
import { ScrollView, StyleSheet, Text, View } from "react-native"
import { DynamicForm } from "../../components/dynamicForm/dynamicForm"
import HeaderWithBack from "../../components/Header/headerWithBack"
import { useCssStyle } from "../../customHook/getCssStyle"
import { MAIN_HEADER_TITLE, SELECTOR_COL_SECONDARY } from "../../style"
import { useTranslation } from "react-i18next"
import { sendAnalytics } from "../../Redux/Actions/analyticsAction"
import { useDispatch } from "react-redux"
import { MOBILE_CHECKIN_CATEGORY } from "../../config/Constant"

export const AdditionalDetails = (props) => {

    const { checkinSessionToken, dynamicFormData, guestDetails, handleGoBack, handleCancel, handleNext, primaryBtnTxt, secondaryBtnTxt } = props;

    const getStyles = useCssStyle();
    const dispatch = useDispatch();
    const { t } = useTranslation();



    useEffect(() => {
        dispatch(sendAnalytics(MOBILE_CHECKIN_CATEGORY, "BOOKING DETAILS", { "element": "widget", "widgetSessionId": checkinSessionToken}));

        // eslint-disable-next-line
    },[])

    const renderHeader = () => {

        return (
            <View style={getStyles(['widgetmainContainerHeaderContainer', 'additionalDetailsHeaderContainer'])}>
                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'additionalDetailsHeaderTitleContainer'])}>
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'additionalDetailsHeaderTitle'])}>{t('check_in.additionaldetails.heading')}</Text>
                    <Text style={getStyles(['widgetmainContainerHeaderSubTitle', 'additionalDetailsHeaderSubTitle'])}>{t('check_in.additionaldetails.sub_heading')}</Text>
                </View>
            </View>
        )
    }

    return (
        <View style={getStyles(['widgetRootContainer', 'additionalDetailsRootContainer'])}>

            <HeaderWithBack handleCustomBackPress={handleGoBack} handleCustomCancelClick={handleCancel} />


            <ScrollView automaticallyAdjustKeyboardInsets={true} contentContainerStyle={getStyles(['widgetmainContainer', 'additionalDetailsMainContainer'])} showsVerticalScrollIndicator={false}>
                {renderHeader()}

                <View style={getStyles(['widgetmainContainerChildContainer', 'additionalDetailsMainContainerChildContainer'])}>
                    <DynamicForm
                        dynamicFormData={dynamicFormData}
                        dynamicFormDataValue={guestDetails?.extraData}
                        guestDetails={guestDetails}
                        handleGoBack={handleGoBack}
                        handleNext={handleNext}
                        primaryBtnTxt={primaryBtnTxt}
                        secondaryBtnTxt={secondaryBtnTxt}
                    />
                </View>
            </ScrollView>
        </View>
    )
}